<template>
  <footer :class="$style.footer">
    <div :class="$style.actions">
      <button
        v-if="currentStep > 1"
        type="button"
        :class="[$style.button, $style.back, { [$style.disabled]: disabled }]"
        :disabled="disabled"
        @click="$emit('back')"
      >
        Назад
      </button>
      <button
        v-else-if="showClose"
        type="button"
        :class="[$style.button, $style.back, { [$style.disabled]: disabled }]"
        :disabled="disabled"
        @click="$emit('clear')"
      >
        <span>Очистить</span>
        <!-- <img src="/figma/step1-close-small.svg" alt="" /> -->
      </button>
      <div v-else :class="$style.spacer" />

      <button
        v-if="currentStep < totalSteps"
        type="button"
        :class="[
          $style.button,
          $style.next,
          { [$style.disabled]: disabled || !canProceed },
        ]"
        :disabled="disabled || !canProceed"
        @click="$emit('next')"
      >
        Далее
      </button>
      <button
        v-else
        type="button"
        :class="[
          $style.button,
          $style.submit,
          { [$style.disabled]: disabled || !canProceed },
        ]"
        :disabled="disabled || !canProceed"
        @click="$emit('submit')"
      >
        Записаться
      </button>
    </div>

    <label v-if="currentStep === totalSteps" :class="$style.consent">
      <input
        :checked="consentAccepted"
        type="checkbox"
        @change="$emit('update:consent-accepted', $event.target.checked)"
      />
      <span>
        Нажимая кнопку «Записаться», вы соглашаетесь с условиями
        <span :class="$style.link">Политики конфиденциальности</span>
        и даете согласие на обработку персональных данных.
      </span>
    </label>

    <div :class="$style.copyright">
      <span>© {{ year }} Все права защищены</span>
      <span>Шиномонтажный калькулятор</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FormFooter",
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    totalSteps: {
      type: Number,
      default: 4,
    },
    canProceed: {
      type: Boolean,
      default: false,
    },
    consentAccepted: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" module>
.footer {
  padding: 1rem 1.5rem 1rem;
  border-top: 1px solid $bg-primary;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @include tablet {
    padding: 1rem;
  }
}

.actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.spacer {
  min-height: 1px;
}

.button {
  min-height: 2.5rem;
  border-radius: 0.25rem;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.back,
.close {
  background-color: $bg-white;
  border: 1px solid $bg-secondary;
  color: $t-secondary;
}

.stepOneClose {
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0;
  color: $t-tertiary;
  font-weight: 600;

  img {
    width: 1rem;
    height: 1rem;
    display: block;
  }
}

.next,
.submit {
  background-color: $green;
  color: $t-white;
}

.next.disabled,
.submit.disabled {
  background-color: $bg-primary;
  color: $t-tertiary;
  opacity: 1;
}

.consent {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  color: $t-secondary;
  font-size: 0.75rem;
  line-height: 1.3;
  text-align: left;

  input {
    width: 1.25rem;
    height: 1.25rem;
    aspect-ratio: 1 / 1;
    min-width: 1.25rem;
    min-height: 1.25rem;
    max-width: 1.25rem;
    max-height: 1.25rem;
    flex: 0 0 1.25rem;
    align-self: flex-start;
    display: inline-block;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid $t-secondary;
    border-radius: 0.125rem;
    background-color: $bg-white;
    cursor: pointer;
    position: relative;
    vertical-align: top;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 0.625rem;
      height: 0.625rem;
      border-radius: 0.125rem;
      background-color: transparent;
      transform: translate(-50%, -50%);
    }

    &:checked {
      background-color: $bg-white;
      border-color: $t-secondary;

      &::after {
        background-color: $green;
      }
    }
  }
}

.link {
  text-decoration: underline;
}

.copyright {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: $t-tertiary;
  font-size: 0.75rem;
  text-align: center;

  span:last-child {
    text-decoration: underline;
  }
}
</style>
